<template>
  <div class="border-top">
    <SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id" />
    <div class="p-l-24 p-r-24 p-d-24" :id="id" v-show="false">
      <SOInputCheckbox :checkboxes="checkList" @selected="selected" :checked="filterItem.statusKonfirmasi" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
  name: "SOFilterStatusKonfirmasi",
  components: {
    SOFilterTitle,
    SOInputCheckbox,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Status Konfirmasi",
    },
    dataOptions: {
      type: Array,
      default: function () {
        return [
          {
            id: "skfrm-1",
            value: "0",
            title: "Belum dikonfirmasi",
            checked: false,
            titleBold: false,
          },
          {
            id: "skfrm-2",
            value: "1",
            title: "Disetujui <span class='f-c-midgrey'>(termasuk yg dihapus owner)</span>",
            checked: false,
            titleBold: false,
          },
          {
            id: "skfrm-3",
            value: "2",
            title: "Ditolak",
            checked: false,
            titleBold: false,
          },
        ]
      }
    }
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem",
    }),
  },
  mounted() {
    if (this.title === "") {
			this.title = "Status Konfirmasi";
		}
    this.diterapkan = this.filterItem.statusKonfirmasi.length > 0;
  },
  data() {
    return {
      checkList: {
        name: "status-konfirmasi",
        data: this.dataOptions,
      },
      diterapkan: false,
    };
  },
  methods: {
    selected(val) {
      let temp = this.filterItem;
      temp.statusKonfirmasi = val;
      this.$store.commit("filterGlobalModule/setFilterItem", temp);
      this.diterapkan = this.filterItem.statusKonfirmasi.length > 0;
    },
  },
};
</script>
